// Chat history is now written server-side by sf-manager 2.1.0 (log_history: true).
// The LOG_HISTORY client-side action has been removed. This saga is kept as a
// registered fork in the root saga but contains no watchers.
export default function* chatbotSaga() {}
